import { Box, HStack, Icon, Pressable } from '@rbilabs/universal-components';
import { Platform } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { getDesignToken, spacing } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

export const Container = HStack.withConfig({
  alignItems: 'center',
});

export const ClickableWrapper = Pressable.withConfig<{ hasAlert: boolean }>(p => ({
  flexDirection: 'row',
  alignItems: 'center',
  height: p.hasAlert ? '$14' : '$12',
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 'auto',
  marginRight: '$1',
  zIndex: 1000,
  _web: {
    cursor: 'pointer',
  },
}));

export const IconContainer = Box.withConfig({
  marginLeft: { base: 0, md: '$1' },
  marginRight: '$2',
});

export const DetailsWrapper = Box.withConfig({
  flex: 1,
});

export const DetailsContainer = HStack.withConfig({
  alignItems: 'center',
  flex: 1,
});

export const Heading = withTypography({
  fontFamily: 'heading',
  numberOfLines: 1,
  fontSize: 'md',
  maxFontSizeMultiplier: 1.5,
});

export const Details = withTypography({
  numberOfLines: 1,
  pl: '$2',
  fontSize: 'md',
  pr: '$1',
  maxFontSizeMultiplier: 1.5,
  style: [
    { flex: 1, overflow: 'hidden', maxWidth: '100%' },
    Platform.select({ web: { textOverflow: 'ellipsis', whiteSpace: 'nowrap' } as any }),
  ],
});

export const SmartAlertText = withTypography({
  numberOfLines: 1,
  fontSize: 'xs',
  bold: true,
  color: getDesignToken('text-default'),
  lineHeight: 17,
  maxFontSizeMultiplier: 1.2,
  style: [
    { flex: 1, overflow: 'hidden' },
    Platform.select({ web: { textOverflow: 'ellipsis', whiteSpace: 'nowrap' } as any }),
  ],
});

export const ButtonWrapper = Box.withConfig({});

export const IconStyled = Icon.withConfig({
  size: '5',
  ...hiddenAccessibilityPlatformProps,
});

export const ArrowRightIcon = Icon.withConfig({
  variant: 'back',
  size: {
    base: 'xs',
    md: 'sm',
  },
  mt: {
    base: spacing.$0_5,
    md: '$1',
  },
  style: {
    transform: [{ rotate: '180deg' }],
  },
});
